/**
 * Calculate the aspect ratio of a media element.
 *
 * Calculate the aspect ratio of a media element.
 * @param {number} width - The width of the media.
 * @param {number} height - The height of the media.
 * @param {'video'|'image'} type - The type of the media.
 * @returns {string} null or the aspect ratio of media element.
 */
export const getAspectRatio = (width, height, type) => {
  if (!width || !height) return null;

  const separator = type === "Video" ? ":" : "/";
  const absWidth = Math.abs(width);
  const absHeight = Math.abs(height);

  const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));

  const divisor = gcd(absWidth, absHeight);

  const simplifiedWidth = absWidth / divisor;
  const simplifiedHeight = absHeight / divisor;

  return `${simplifiedWidth}${separator}${simplifiedHeight}`;
};
